import React from 'react';
import { AlertTriangle } from 'lucide-react';

const B2BNotice = () => {
  return (
    <div className="bg-primary/10 border-t border-b border-primary/30 py-2">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-center gap-2 text-sm">
          <AlertTriangle className="w-4 h-4 text-primary flex-shrink-0" />
          <span className="text-primary font-medium">
            Nur für gewerbliche Kunden, keine privaten Anfragen oder Aufträge!
          </span>
          <span className="text-zinc-500 text-xs ml-2 hidden sm:inline">
            Styropor® ist eine eingetragene Marke der BASF SE.
          </span>
        </div>
      </div>
    </div>
  );
};

export default B2BNotice;
